// DeleteConfirmModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { deleteMyListData } from "../../redux/action";
import { useDispatch } from "react-redux";
import * as HeaderAuthentication from '../../HeaderAuthentication'

const DeleteMyListModal = ({ show, onHide, selectedSearch, fetchMyListData, sbnID, signInID }) => {

    const dispatch = useDispatch();
    const handleEditSavedSearches = () => {
        const requestPayload = {
            list_name: selectedSearch.list_name,
            sbn_id: sbnID,
            user_id: parseInt(signInID)
        }

        const requestOption = {
            ...HeaderAuthentication.deleteAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };
        // console.log(requestPayload, 'requestPayload')
        dispatch(deleteMyListData(requestOption, fetchMyListData, onHide));
    };

    return (
        <Modal show={show} onHide={onHide} centered className="saved-search-modal">
            <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={handleEditSavedSearches}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteMyListModal;
